var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 34q-.65 0-1.075-.425T6 32.5t.425-1.075T7.5 31t1.075.425T9 32.5t-.425 1.075T7.5 34m0-8.5q-.65 0-1.075-.425T6 24t.425-1.075T7.5 22.5t1.075.425T9 24t-.425 1.075T7.5 25.5m0-8.5q-.65 0-1.075-.425T6 15.5t.425-1.075T7.5 14t1.075.425T9 15.5t-.425 1.075T7.5 17m7 17v-3H42v3Zm0-8.5v-3H42v3Zm0-8.5v-3H42v3Z"
  })));
};
export default SvgList;